export default {
    drawer: (state) => state.app.drawer
  };
  